// internet-check.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InternetCheckService {

    private online$ = new BehaviorSubject<boolean>(navigator.onLine);

    constructor() {
        window.addEventListener('online', () => this.updateOnlineStatus());
        window.addEventListener('offline', () => this.updateOnlineStatus());
    }

    private updateOnlineStatus () {
        this.online$.next(navigator.onLine);
    }

    isOnline (): Observable<boolean> {
        return this.online$.asObservable();
    }
}
